import React, { useState, useEffect, useRef } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { useLocation, useNavigate } from "react-router-dom";
import Button from "./Button";

function ContactformRev({ property_name, formName }) {

  console.log("property_name", property_name)
  const navigate = useNavigate();
  const { pathname } = useLocation();
  console.log(pathname);
  const page = pathname.split("/").filter(Boolean);
  const key = page.length === 2 ? page[1] : page[0];
  console.log(key)
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);
  const now = new Date();
  const CurrentDate = new Date().toISOString().split("T")[0]
  const CurrentTime = now.toTimeString().split(" ")[0];
  const initialvalues = {
    name: "",
    email: "",
    phonenumber: "",
    message: "",
    date_of_enquiry: CurrentDate,
    time_of_enquiry: CurrentTime,
    consent: true,
  };
  console.log(CurrentTime)
  const [formValues, setFormValues] = useState(initialvalues);
  const form = useRef();
  const [formErrors, setFormErrors] = useState(false);

  const primary_paths = [
    "/apartments-and-villas-for-sale-in-coimbatore",
    "/plots-for-sale-in-coimbatore",
    "/buy-house-in-coimbatore",
    "/residential",
    "/office-space-for-rent-in-coimbatore",
  ];

  let thank_you_value;
  if (pathname === primary_paths[0]) {
    thank_you_value = "apartments";
  } else if (pathname === primary_paths[1]) {
    thank_you_value = "plots";
  } else if (pathname === primary_paths[2]) {
    thank_you_value = "resale"
  } else if (pathname === primary_paths[4]) {
    thank_you_value = "commercial"
  }

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormValues({
      ...formValues,
      [name]: type === "checkbox" ? checked : value,
    });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const error = validate(formValues);
    console.log(error)
    setFormErrors(error);
    if (Object.keys(error).length === 0) {
      handleGSheet();
      setFormValues(initialvalues);
      setTimeout(() => {
        navigate(`/thank-you/${thank_you_value}`);
      }, 1000);
    }
  };

  //Error hiding function (UX Improvement)
  const handleFocus = (e) => {
    const { name } = e.target;
    if (formErrors[name]) {
      setFormErrors((prev) => {
        const updatedErrors = { ...prev };
        delete updatedErrors[name];
        return updatedErrors;
      });
    }
  };

  const validate = (values) => {
    const errors = {};
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;

    if (!values.name) {
      errors.name = "Name is Required";
    }

    if (!values.email) {
      errors.email = "Email is Required";
    } else if (!regex.test(values.email)) {
      errors.email = "Invalid email";
    }
    if (!values.phonenumber) {
      errors.phonenumber = "Phone Number is Required";
    } else if (isNaN(values.phonenumber)) {
      errors.phonenumber = "Invalid Phone Number";
    } else if (values.phonenumber.length !== 10) {
      errors.phonenumber = "Invalid Phone Number";
    }
    if ((!values.service && !primary_paths.includes(pathname)) || (!values.service && primary_paths.includes(pathname) && formName != 1)) {
      errors.service = "Please select a service";
    }
    if (!values.type && primary_paths.includes(pathname) && formName === 1 && pathname != "/office-space-for-rent-in-coimbatore") {
      errors.type = "Please select a type"
    }
    if (!values.willingToBuy && primary_paths.includes(pathname) && formName === 1 && pathname != "/office-space-for-rent-in-coimbatore") {
      errors.willingToBuy = "Please select a timeline"
    }
    if (!values.consent) {
      errors.consent = "Please accept the terms to continue";
    }
    return errors;
  };

  useEffect(() => {
    if (key === "residential" || key === "office-space-for-rent-in-coimbatore" || key === "apartments-and-villas-for-sale-in-coimbatore" || key === "plots-for-sale-in-coimbatore" || key === "buy-house-in-coimbatore") {
      setFormValues((prev) => ({
        ...prev,
        property_name: property_name,
        page_data: key
      }));
    } else {
      setFormValues((prev) => ({
        ...prev, page_data: key
      }))
    }
  }, [property_name]);

  const handleGSheet = () => {
    console.log(formValues);
    let url = "";

    if (key === "residential" || key === "office-space-for-rent-in-coimbatore" || key === "apartments-and-villas-for-sale-in-coimbatore" || key === "plots-for-sale-in-coimbatore" || key === "buy-house-in-coimbatore") {
      // Residential sheet API
      url =
        "https://script.google.com/macros/s/AKfycbxZBjt2g3w_92ReBF1_t-iEo5NxFcR4rr4EJMeGuMdoyPKfjMR9Tk8S1XXpO9RIj36Q/exec";
    } else {
      // contact sheet API
      url =
        "https://script.google.com/macros/s/AKfycbxWW-g7KhZbeAu3oPdg-3Q3vsfRxLTec-60RlK3NVyQNKhIIfUKRT0Q3iNyoKJ3wO4P/exec";
    }
    fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams(formValues).toString(),
    })
      .then((res) => res.text(console.log("response", res)))
      .then((data) => {
        console.log("data", data);
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  return (
    <>
      {/* Modal */}
      <div
        className={
          pathname === "/contact"
            ? " mx-auto mt-20 lg:mx-none lg:mt-0 px-4 sm:px-0"
            : "w-full h-full mx-auto sm:mt-[10px] sm:px-0"
        }
        data-aos="fade-up"
      >
        <h2 className="text-center font-alibaba  text-[18px] leading-[27px] sm:text-[30px] font-bold sm:leading-[45px] capitalize">
          Place your Enquiry!
        </h2>
        <hr className="border-yellow border-[2px] w-[50px] lg:w-[87px] mx-auto sm:mt-5 sm:mb-6 my-3" />

        <div>
          <form
            className={
              pathname === "/contact"
                ? "flex flex-col gap-y-3 sm:gap-y-7"
                : "flex flex-col gap-y-3 sm:gap-y-2"
            }
            ref={form}
            onSubmit={handleSubmit}
          >
            <div>
              <p className="input-heading">
                Name <span className="text-[#FF0000]">*</span>
              </p>
              <input
                className="input-box"
                type="text"
                name="name"
                onChange={handleChange}
                onFocus={handleFocus}
              />
              <span className="error-msg">{formErrors.name} </span>
            </div>

            <div>
              <p className="input-heading">
                Phone <span className="text-[#FF0000]">*</span>
              </p>
              <input
                className="input-box"
                type="Phone"
                name="phonenumber"
                onChange={handleChange}
                onFocus={handleFocus}
              />
              <span className="error-msg">{formErrors.phonenumber}</span>
            </div>

            <div>
              <p className="input-heading">
                Email <span className="text-[#FF0000]">*</span>
              </p>
              <input
                className="input-box"
                type="Email"
                name="email"
                onChange={handleChange}
                onFocus={handleFocus}
              />
              <span className="error-msg">{formErrors.email}</span>
            </div>

            <div className={primary_paths.includes(pathname) && formName === 1 && pathname != "/office-space-for-rent-in-coimbatore" ? 'block' : "hidden"}>
              <p className="input-heading">Type <span className="text-[#FF0000] font-alibaba">*</span></p>
              <select className="input-box" name="type" onChange={handleChange} onFocus={handleFocus}>
                <option value={"bhk"} disabled selected>-Please Select a type-</option>
                <option value={"1bhk"}>1 BHK</option>
                <option value={"2bhk"}>2 BHK</option>
                <option value={"3bhk - more"}>3 BHK & More</option>
              </select>
              <span className="error-msg">{formErrors.type}</span>
            </div>

            <div className={primary_paths.includes(pathname) && formName === 1 && pathname != "/office-space-for-rent-in-coimbatore" ? 'block' : "hidden"}>
              <p className="input-heading">Willing to buy <span className="text-[#FF0000] font-alibaba">*</span></p>
              {/*  */}
              <div className="flex gap-x-6 mt-2">
                {/* option 1 */}
                <div className="flex items-center">
                  <input
                    type="radio"
                    name="willingToBuy"
                    value="1-3 months"
                    className="w-5 h-5 text-blue-600 border-grey mr-2"
                    onChange={handleChange}
                    onFocus={handleFocus}
                  />
                  <label className="">1 - 3 months</label>
                </div>
                {/* option 2 */}
                <div className="flex items-center">
                  <input
                    type="radio"
                    name="willingToBuy"
                    value="Not Sure"
                    className="w-5 h-5 text-blue-600 border-grey mr-2 my-auto"
                    onChange={handleChange}
                    onFocus={handleFocus}
                  />
                  <label className="my-auto">Not Sure</label>
                </div>
              </div>
              <span className="error-msg">{formErrors.willingToBuy}</span>
            </div>

            <div className={primary_paths.includes(pathname) && formName != 1 || !primary_paths.includes(pathname) ? 'block' : "hidden"}>
              <p className="input-heading">Service Required? <span className="text-[#FF0000] font-alibaba">*</span></p>
              <select className="input-box" name="service" onChange={handleChange} onFocus={handleFocus}>
                <option value={"Brokerage"} disabled selected>-Please Select a Service-</option>
                <option value={"Brokerage"}>Brokerage</option>
                <option value={"Commercial - Rental"}>
                  Commercial - Rental
                </option>
                <option value={"Liaison"}>Liaison</option>
                <option value={"Registration"}>Registration</option>
                <option value={"Digital Survey"}>Digital Survey</option>
                <option value={"Registration"}>Registration</option>
                <option value={"Architect & Construction"}>Architect & Construction</option>
                <option value={"Agri-Property Management"}>Agri-Property Management</option>
              </select>
              <span className="error-msg">{formErrors.service}</span>
            </div>

            <div className={primary_paths.includes(pathname) && formName === 1 ? 'block' : "hidden"}>
              <p className="input-heading">Selected Property</p>
              <input
                className="input-box"
                type="text"
                name="selectedProperty"
                disabled
                value={property_name}
                onFocus={handleFocus}
              />
            </div>

            <div>
              <p className="input-heading">Tell us more</p>
              <textarea
                className="message-box"
                rows="4"
                cols="40"
                name="message"
                onChange={handleChange}
              />
            </div>
            <div className="max-w-[380px] flex items-start  gap-3  ">
              <input
                type="checkbox"
                name="consent"
                checked={formValues.consent}
                onChange={handleChange}
                className="mt-2 accent-yellow border-[#800020]"
              />

              <h1 className="text-[13px] text-[#757575]">
                By submitting this form, I consent to receive communications from the
                Lands and Lands through WhatsApp, SMS, email, phone calls, and other
                channels, even if my number is registered on DND/NDNC.
              </h1>
            </div>
            {formErrors.consent && (
              <p className="text-[#FF0000] text-sm mt-1">
                {formErrors.consent}
              </p>
            )}
            <Button name={"Submit"} design={"filled"} action={"form-submit"} />
          </form>
        </div>
      </div>
    </>
  );
}

export default ContactformRev;
